import React from "react";
import { ImageProps } from "@chakra-ui/image/dist/types/image";
import { Link } from "react-router-dom";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { CustomLogoImage } from "./CustomLogoImage";

interface IProps extends ImageProps {
  logoUrl: string;
}

const CustomLogo = ({ logoUrl, ...restProps }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { logoMainHref } = useContextConsumer();
  const logoHref = logoMainHref || `/e-rezerwacja/${friendlyUrl}`;

  if (!logoMainHref) {
    return (
      <Link to={`/e-rezerwacja/${friendlyUrl}`}>
        <CustomLogoImage logoUrl={logoUrl} {...restProps} />
      </Link>
    );
  }

  return (
    <a href={logoHref}>
      <CustomLogoImage logoUrl={logoUrl} {...restProps} />
    </a>
  );
};

export { CustomLogo };
